import {
  ChangeEventHandler,
  FC,
  Fragment,
  InputHTMLAttributes,
  useMemo,
} from "react";

export type InputWithUnitprops = InputHTMLAttributes<HTMLInputElement> & {
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
};

export const InputWithUnit: FC<InputWithUnitprops> = ({
  value,
  onChange,
  ...props
}) => {
  const [amount, unit] = useMemo(() => {
    const splitted = value.split(" ");
    if (splitted.length != 2) return [0, ""];
    return splitted;
  }, [value]);

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const overwrite = { ...event };
    overwrite.target.value = `${event.target.value} ${unit.toLowerCase()}`;

    console.debug("override");
    console.debug(overwrite.target.value);

    onChange(overwrite);
  };

  return (
    <Fragment>
      <div className="flex flex-row gap-2 items-center">
        <div className="relative rounded-md">
          <input
            {...props}
            className={`block w-full rounded-md pl-2 pr-[35px] text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:border-primary sm:text-sm sm:leading-6 ${props?.className}`}
            value={amount}
            onChange={handleChange}
          />
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <span
              id="price-currency"
              className="text-gray-500 sm:text-sm text-left"
            >
              {unit}
            </span>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
